import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import styles from "../TaskToDo/styles.module.scss";
import ArrowRight from "@assets/icons/leftArrow";
import { Subtask } from "..";
import { useNavigate } from "react-router-dom";

export interface SubtaskListProps {
  readonly subtasks: Subtask[];
  readonly isTaskDone: boolean;
  readonly onToggleSubtask: (subtaskId: number) => void;
}

interface SubtaskListItemProps {
  readonly subtask: Subtask;
  readonly index: number;
  readonly allPrevCompleted: boolean;
  readonly isTaskDone: boolean;
  readonly onToggleSubtask: (subtaskId: number) => void;
  readonly onNavigateFirst: () => void;
}

const SubtaskListItem: React.FC<SubtaskListItemProps> = ({
  subtask,
  index,
  allPrevCompleted,
  isTaskDone,
  onToggleSubtask,
  onNavigateFirst,
}) => {
  const canToggle = !isTaskDone && (index === 0 || allPrevCompleted);
  const isLocked = !canToggle;
  const isSubtaskDone = isTaskDone || !!subtask.completed;
  const finalDone = canToggle && isSubtaskDone;

  let titleClass: string;
  if (finalDone) {
    titleClass = styles.subtaskTitleDone;
  } else if (isLocked) {
    titleClass = styles.subtaskTitleLocked;
  } else {
    titleClass = styles.subtaskTitle;
  }

  let descClass = styles.subtaskDescription;
  if (subtask.description) {
    if (finalDone) {
      descClass = styles.subtaskDescriptionDone;
    } else if (isLocked) {
      descClass = styles.subtaskDescriptionLocked;
    } else {
      descClass = styles.subtaskDescription;
    }
  }

  return (
    <div className={styles.subtaskItem}>
      <button
        type="button"
        onClick={() => {
          if (canToggle) {
            onToggleSubtask(subtask.id);
          } else {
            console.log("error");
          }
        }}
        className={[
          styles.subtaskCircle,
          finalDone && styles.subtaskCircleDone,
          isLocked && styles.subtaskCircleLocked,
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {finalDone && <CheckOutlined className={styles.checkIcon} />}
      </button>
      <div className={styles.subtaskText}>
        <div className={titleClass}>
          {subtask.title}
          {!isTaskDone && index === 0 && (
            <button
              type="button"
              onClick={onNavigateFirst}
              className={styles.arrowRightRotated}
            >
              <ArrowRight />
            </button>
          )}
        </div>
        {subtask.description && (
          <p className={descClass}>{subtask.description}</p>
        )}
      </div>
    </div>
  );
};

export const SubtaskList: React.FC<SubtaskListProps> = ({
  subtasks,
  isTaskDone,
  onToggleSubtask,
}) => {
  const navigate = useNavigate();

  const handleFirstNav = () => {
    const first = subtasks[0];
    if (!first.completed && first.title === "Optimize Content") {
      navigate("/CRO-module");
    } else {
      console.log("error");
    }
  };

  return (
    <div className={styles.subtaskList}>
      {subtasks.map((subtask, idx) => {
        const allPrevCompleted =
          idx > 0 ? subtasks.slice(0, idx).every((s) => s.completed) : false;
        return (
          <SubtaskListItem
            key={subtask.id}
            subtask={subtask}
            index={idx}
            allPrevCompleted={allPrevCompleted}
            isTaskDone={isTaskDone}
            onToggleSubtask={onToggleSubtask}
            onNavigateFirst={handleFirstNav}
          />
        );
      })}
    </div>
  );
};
